/* eslint-disable camelcase */
import InteractionStudioCodes from '../../scripts/constants/interaction-studio-types.js';
import asyncActionTypes from './types.js';

export const LOGIN_VIEW = () => ({
  type: asyncActionTypes.LOGIN_VIEW,
});

export const REGISTER = (response) => (
  {
    type : asyncActionTypes.REGISTER,
    payload : response,
  }
);

export const REGISTER_VIEW = () => ({
  type: asyncActionTypes.REGISTER_VIEW,
});

export const LOGIN_ACTION = (response) => ({
  type: asyncActionTypes.LOGIN_ACTION,
  payload: {
    ffn_dp_id: response?.clubPremierID || '',
    userEmailCp: response?.userEmailCp || '',
  },
});

export const SESION_EXPIRE = () => ({
  type: asyncActionTypes.SESION_EXPIRE,
});

export const SEARCH_ITINERARY = (response) => {
  const pnrApellido = `${response.pnr}${response.lastName}`;

  return ({
    type: asyncActionTypes.SEARCH_ITINERARY,
    payload: { pnrApellido },
  });
};

export const QUICK_VIEW_ITEM = (response) => ({
  type: asyncActionTypes.QUICK_VIEW_ITEM,
  payload: response,
});

export const STOP_VIEW_ITEM = (response) => ({
  type: asyncActionTypes.STOP_VIEW_ITEM,
  payload: response,
});

export const ADD_TO_CART = (response) => {
  const { sendEvent, ...lineItem } = response;
  return ({
    type: asyncActionTypes.ADD_TO_CART,
    payload: {
      lineItem,
      sendEvent,
    },
  });
};

export const REMOVE_FROM_CART = (response) => {
  const { sendEvent, ...lineItem } = response;

  return ({
    type: asyncActionTypes.REMOVE_FROM_CART,
    payload: {
      lineItem,
      sendEvent,
    },
  });
};

export const UPDATE_CART = (response) => ({ type: asyncActionTypes.UPDATE_CART, payload: { ...response } });

export function PURCHASE(dataEvent, orderId) {
  const payload = {
    currency: dataEvent.currency,
    lineItems: dataEvent.lineItems,
    orderId,
    totalValue: dataEvent.totalValue,
  };

  return {
    type: asyncActionTypes.PURCHASE,
    payload,
  };
}

export function VIEW_CART(listItem) {
  return {
    type: asyncActionTypes.VIEW_CART,
    payload: listItem,
  };
}

export const BOOKING_STEPFORM = () => ({ type: asyncActionTypes.BOOKING_STEPFORM });

export function ACTION_LOGIN(active) {
  return {
    type: asyncActionTypes.ACTION_LOGIN,
    payload: active,
  };
}

export function MYB_ANCILLARY_PERSONALIZATION(payload) {
  return {
    type: InteractionStudioCodes.MYB_ANCILLARY_PERSONALIZATION,
    payload,
  };
}

export function MYB_ANCILLARY_PERSONALIZATION_CONTROL(payload) {
  return {
    type: InteractionStudioCodes.MYB_ANCILLARY_PERSONALIZATION_CONTROL,
    payload,
  };
}

export function IMPRESSION_TRAKING_PERSONALIZATION(payload) {
  return {
    type: InteractionStudioCodes.TRAKING_IMPRESSION,
    payload,
  };
}
